type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/**
 * YouTube Shorts comment glyph — outlined rounded-rectangle speech bubble
 * with a short tail at the bottom-left. Matches the shape YouTube paints on
 * the Shorts surface action rail: more square than the generic round
 * `CommentsIcon` used by other overlays, with the tail dropping from the
 * left edge rather than the center.
 */
const YouTubeShortsCommentIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    strokeColor = 'currentColor',
    strokeWidth = '1.8',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      {/* Closed bubble outline: rounded rectangle with a tail extending
          down-left from the bottom edge. */}
      <path
        d="M5 4 H 19 A 2 2 0 0 1 21 6 V 16 A 2 2 0 0 1 19 18 H 10 L 6 22 V 18 H 5 A 2 2 0 0 1 3 16 V 6 A 2 2 0 0 1 5 4 Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default YouTubeShortsCommentIcon;
